import { useMailActions } from '@ukpostbox/client-data';
import { GetArrayIndexByKeyValue } from '@ukpostbox/helpers';
import { useState } from 'react';

const useMailItemActions = () => {
	const { data, status: mailItemActionsStatus, error: mailItemActionsError } = useMailActions();
	const [selectionActions, setSelectionActions] = useState<Array<any>>([]);

	const FilterActions = (mailData: any, selected: Array<any>) => {
		if (!mailData || !data || !data?.data || data?.data?.length < 1 || !selected || selected.length < 1) {
			setSelectionActions([]);
			return;
		}

		const selectedData = mailData.pages
			? mailData.pages.map((group: any) =>
					group.data.filter((mailItem: any) => (selected.includes(mailItem.mailUuid) ? mailItem : null)),
				)[0]
			: mailData;
		let newActions: Array<any> = [];
		const exclude: Array<string> = [];

		for (let i = 0; i < selectedData.length; i += 1) {
			if (data?.data && selectedData[i].actions?.length === 0) {
				data?.data.forEach((item) => exclude.push(item.name));
			}

			for (let j = 0; j < selectedData[i].actions?.length; j += 1) {
				if (data?.data) {
					newActions = [...data.data];
					for (let k = 0; k < newActions.length; k += 1) {
						const newEntry = GetArrayIndexByKeyValue(selectedData[i].actions, 'name', newActions[k].name);

						if (newEntry === -1 && !exclude.includes(newActions[k].name)) {
							exclude.push(newActions[k].name);
						}
					}
				}
			}
		}

		if (exclude.length > 0) {
			const exclusions = exclude.filter((v, i, a) => a.indexOf(v) === i);

			for (let m = newActions.length - 1; m >= 0; m -= 1) {
				if (exclusions.includes(newActions[m].name)) {
					newActions.splice(m, 1);
				}
			}
		}

		setSelectionActions(newActions);
	};

	return { mailItemActionsError, mailItemActionsStatus, selectionActions, FilterActions };
};

export default useMailItemActions;
